import ExperienceInfo from './ExperienceInfo';
import './ExperienceInfo.scss';

export default ExperienceInfo;
